import { useParams } from "react-router-dom";
import { EditInspectionForm } from "src/components/Forms/EditInspectionForm";
export function EditInspectionDeviation() {
  const { deviationId } = useParams();
  return <EditInspectionForm id={deviationId || ""} />;
}
